import { OnlineSales } from 'gw-edge-client';
import { useRecoilValue } from 'recoil';
import { jobInfoAtom } from '../recoil/atoms/jobInfoAtom';
import { isAxiosError } from 'axios';
import { useOpcInfomation } from './useOpcInfomation';
export const useValidateTermChangeOPC = (): {
    isNewTermValidatedSuccessfully: (termValue: number) => Promise<boolean>;
} => {
    const { jobNumber, sessionId } = useRecoilValue(jobInfoAtom);
    const { productName, coverageId, coverableId, termId } = useOpcInfomation().termChange;

    const isNewTermValidatedSuccessfully = async (termValue: number): Promise<boolean> => {
        if (productName !== 'top_mvp_car') return true;
        try {
            await OnlineSales.validateOPCEditTerm(jobNumber, sessionId, {
                productName,
                coverableId,
                coverageId,
                termId,
                termValue
            });
        } catch (e) {
            if (
                isAxiosError(e) &&
                (e.response?.data.error.pureMessage_Top as string)
                    .toLowerCase()
                    .includes('cannot choose this new value')
            ) {
                return false;
            }
            throw new Error('Fail to validate');
        }
        return true;
    };
    return { isNewTermValidatedSuccessfully };
};
